import { render, staticRenderFns } from "./FormSection.vue?vue&type=template&id=f0fed79e&scoped=true&"
import script from "./FormSection.vue?vue&type=script&lang=ts&"
export * from "./FormSection.vue?vue&type=script&lang=ts&"
import style0 from "./FormSection.vue?vue&type=style&index=0&id=f0fed79e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0fed79e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VDivider})
